import Compressor from 'compressorjs'
import { mutationTypes, actionTypes } from 'BASE/store/types'
import LotteryConstant from 'BASE/common/lotteryConstant'
import CONSTANT from 'BASE/common/chat/chat.constant'
import SETTING from 'BASE/common/chat/chat.setting'
import signalr from 'BASE/common/signalrAdapter'
import transform from 'BASE/common/chat/chat.transformServerName'
import GroupRoomMemberRequestBuilder from 'BASE/common/chat/chat.groupRoomMemberRequestBuilder'
import { storage } from 'BASE/common/util/util.storage';
import * as model from 'BASE/store/chat/chat.store.model'
import UTIL from 'BASE/common/chat/chat.util';

let reconnectedSyncTimeout = undefined;

export default class {
    constructor() {
        this[actionTypes.CHAT_SIGNALR_STATE_CHANGED] = async (context, payload) => {
            let oldState = payload.oldState;
            let newState = payload.newState;

            // 更新signalr上線狀態
            context.commit(mutationTypes.CHAT_SET_CONNECTION_STATE, {
                isConnected: newState,
            });

            // 斷線->連線
            if (!oldState && newState) {
                if (!context.state.isAnonymity) {
                    // 已登入
                    // 重新連接全站群聊
                    await this.reEnterSiteGroupRoom(context);
                    // 更新已開啟的聊天室
                    await this.refreshRoomWindows(context);
                    // 同步聊天室資料
                    await this.reconnectedSync(context);
                } else {
                    // 未登入
                    // do nothing
                }
            }
        };

        this[actionTypes.CHAT_OPEN_ROOM_WINDOW] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;
            let isAddCustomerServiceWaiting = payload.isAddCustomerServiceWaiting;
            let siteGroupSystemMessage = payload.siteGroupSystemMessage;

            let roomWindow = context.state.roomWindows.find((item) => {
                return item.room.id === roomId;
            });

            // 目前已開啟
            if (roomWindow && roomWindow.showTime) {
                return;
            }

            // 開啟視窗
            if (!roomWindow) {
                // 第一次開啟

                // 下載群組聊天室成員資訊
                await this.loadGroupRoomMember(context, roomId);

                // 下載歷史訊息
                await this.loadHistoryMessage(context, roomId);

                // 新增全站群聊系統訊息
                this.addSiteGroupSystemMessage(context, roomId, siteGroupSystemMessage)

                // 加入客服或顯示提示訊息
                await this.doCustomerServiceOnOpenWindow(context, roomId, isAddCustomerServiceWaiting);

                context.commit(mutationTypes.CHAT_ADD_ROOM_WINDOW, { roomId: roomId });
                context.commit(mutationTypes.CHAT_OPEN_ROOM_WINDOW, { roomId: roomId });

            } else if (!roomWindow.showTime) {
                context.commit(mutationTypes.CHAT_OPEN_ROOM_WINDOW, { roomId: roomId });
            }

            // NOTICE: 先開啟新的視窗 再關閉其他的視窗 畫面才不會閃爍
            // 關閉已開啟的視窗(排除點選的聊天室)
            this.closeActivedRoomWindow(context, roomId);

            // 未讀訊息歸0
            context.commit(mutationTypes.CHAT_INCREMENT_UNREAD_NUMBER, { roomId: roomId, count: 0 });

            // 更新房間時間
            this.updateRoomActiveTime(context, roomId, true);

            //更新當前對話名單的時間
            let onTalkTime = new Date();
            this.updateOnTalk(context, roomId, onTalkTime);

            // 紀錄最後開啟的roomId(Cordova APP恢復用)
            storage.local.set(storage.keys.LAST_CHATROOMID, roomId);

            //給頁面功能客制化時使用
            this.afterOpenRoomWindow({context, newRoomId: roomId});
        });

        this[actionTypes.CHAT_CLOSE_ROOM_WINDOW] = (context, payload) => {
            let roomId = payload.roomId;
            let onTalkTime = payload.onTalkTime;

            let roomWindow = context.state.roomWindows.find((item) => {
                return item.room.id === roomId;
            });

            // 已開啟的狀態才需要做關閉
            if (roomWindow && roomWindow.showTime) {
                this.closeRoomWindow(context, roomId);
            }

            //更新當前對話名單
            this.updateOnTalk(context, roomId, onTalkTime);

            // 清除最後開啟的roomId(Cordova APP恢復用)
            storage.local.remove(storage.keys.LAST_CHATROOMID);
        };

        this[actionTypes.CHAT_REMOVE_ROOM_WINDOW] = (context, payload) => {
            const roomId = payload.roomId;
            context.commit(mutationTypes.CHAT_REMOVE_ROOM_WINDOW, { roomId });
            context.commit(mutationTypes.CHAT_REMOVE_ROOM_MESSAGE_CONTAINER, { roomId });
        };

        this[actionTypes.CHAT_RELOAD_HISTORY_MESSAGE] = async (context, payload) => {
            let roomId = payload.roomId;
            await this.loadHistoryMessage(context, roomId);
        };

        this[actionTypes.CHAT_SEND_MESSAGE] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;
            let type = payload.type;
            let content = payload.content;
            await this.sendMessage(context, roomId, type, content);
        });

        this[actionTypes.CHAT_SEND_MESSAGE_MULTICAST] = async (context, payload) => {
            let roomIds = payload.roomIds;
            let type = payload.type;
            let content = payload.content;
            return await this.sendMessageMulticast(context, roomIds, type, content);
        };

        this[actionTypes.CHAT_RECEIVE_MESSAGE] = (context, payload) => {
            payload = transform.transformRoomMessage(payload);
            let roomId = payload.roomId;
            let userId = payload.userId;
            let type = payload.type;
            let name = payload.name;
            let content = payload.content;
            let timestamp = payload.timestamp

            // 全站群聊的導師聊天室有可能是沒有建立的狀態，收到訊息時要先建立導師聊天室
            const serverRoomType = UTIL.getServerRoomType(roomId)
            if (serverRoomType === CONSTANT.serverRoomType.SITE_GROUP_TUTOR) {
                context.dispatch(actionTypes.CHAT_SITE_GROUP_ADD_TUTOR_ROOM, {
                    roomId: roomId,
                    name: name,
                    image: payload.headImage,
                })

                // 有訊息後才開始導師聊天
                context.commit(mutationTypes.CHAT_SITE_GROUP_START_TUTOR_TALKING, payload);
            }

            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, payload);

            // 沒有開啟視窗就增加未讀訊息數量
            let roomWindow = context.state.roomWindows.find((item) => {
                return item.room.id === roomId;
            });
            if (!roomWindow || !roomWindow.showTime) {
                // 非自己送的訊息才需增加未讀訊息數量
                if (userId !== context.state.userId) {
                    context.commit(mutationTypes.CHAT_INCREMENT_UNREAD_NUMBER, { roomId: roomId, increment: 1 });
                }
            }

            // 更新最後的聊天訊息
            context.commit(mutationTypes.CHAT_UPDATE_LAST_MESSAGE, {
                roomId: roomId,
                userId: userId,
                type: type,
                name: name,
                content: content,
                timestamp: timestamp,
            });
        };

        this[actionTypes.CHAT_UPLOAD_IMAGE] = this.checkConnectionAsyncAction(async (context, payload) => {     
            let roomId = payload.roomId;
            let files = payload.files;

            let errorMessage = this.checkUploadImageLimit(files);

            let compressResult = undefined;
            if (!errorMessage) {
                compressResult = await this.compressImage(files[0]);
                if (!compressResult) {
                    errorMessage = SETTING.messages.UPLOAD_IMAGE_COMPRESS_FAILED();
                }
            }

            if (!errorMessage) {
                let formData = new FormData();
                formData.append('files', compressResult, compressResult.name);

                try {
                    let result = await $.ajax({
                        url: "/api/Chat/UploadImage",
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                    });

                    let code = result.Code;
                    let url = result.Url;
                    if (code === CONSTANT.code.SUCCESS) {
                        await this.sendMessage(context, roomId, CONSTANT.messageType.IMAGE, url);
                    } else {
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_UPLOAD_IMAGE);
                        console.log(`[${actionTypes.CHAT_UPLOAD_IMAGE}] result code ${code}`);
                    }
                } catch (err) {
                    console.error(err);
                    errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_UPLOAD_IMAGE);
                }
            }

            if (errorMessage) {
                if (errorMessage !== "") {
                    context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                        roomId: roomId,
                        type: CONSTANT.messageType.WARNING,
                        content: errorMessage,
                    });
                }
            }
        });

        this[actionTypes.CHAT_ADD_CUSTOMER_SERVICE_WAITING] = this.checkConnectionAsyncAction(async (context, payload) => {
            let questionType = payload ? payload.questionType : undefined;
            let room = context.state.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE);
            let errorMessage;
            let errorMessageType = CONSTANT.messageType.WARNING;
            try {
                let result = await signalr.chatServer.addCustomerServiceWaiting({ RoomId: room.id, QuestionType: questionType });
                let code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                    case CONSTANT.code.CUSTOMER_SERVICE_WAITING:
                        errorMessageType = CONSTANT.messageType.CUSTOMER_SERVICE_WAITING_INFO;
                        errorMessage = SETTING.messages.CUSTOMER_SERVICE_WAITING();
                        break;
                    case CONSTANT.code.CUSTOMER_SERVICE_SERVING:
                        errorMessageType = CONSTANT.messageType.INFO;
                        errorMessage = SETTING.messages.CUSTOMER_SERVICE_SERVING();
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.ADD_CUSTOMER_SERVICE_WAITING);
                        console.log(`[addCustomerServiceWaiting] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.ADD_CUSTOMER_SERVICE_WAITING);
            }

            if (errorMessage) {
                context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                    roomId: room.id,
                    type: errorMessageType,
                    content: errorMessage,
                });
            }
        });

        this[actionTypes.CHAT_START_CUSTOMER_SERVICE_SERVING] = (context, payload) => {
            let sessionId = payload.sessionId;
            let isAlreadyRating = payload.isAlreadyRating;
            context.commit(mutationTypes.CHAT_SET_CUSTOMER_SERVICE_SESSION_ID, {
                sessionId: sessionId,
                isAlreadyRating: isAlreadyRating
            });
        };

        this[actionTypes.CHAT_FINISH_CUSTOMER_SERVICE_SERVING] = (context) => {
            let room = context.state.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE);
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                roomId: room.id,
                type: CONSTANT.messageType.INFO,
                content: SETTING.messages.CUSTOMER_SERVICE_SERVING_FINISH(),
            });
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                roomId: room.id,
                type: CONSTANT.messageType.CUSTOMER_SERVICE_QUESTION_LIST,
                content: SETTING.messages.CUSTOMER_SERVICE_QUESTION_LIST(),
            });
        };

        this[actionTypes.CHAT_ADD_GROUP_ROOM] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomName = payload.roomName.trim();

            let errorMessage;
            errorMessage = this.checkGroupRoomNameLength(roomName);
            if (!errorMessage) {
                try {
                    let result = await signalr.chatServer.addGroupRoom({ Name: roomName });
                    let code = result.Code;
                    switch (code) {
                        case CONSTANT.code.SUCCESS:
                            context.commit(mutationTypes.CHAT_ADD_ROOM, {
                                room: transform.transformRoom(result.Room),
                                members: result.Room.Members.map((item) => transform.transformRoomMember(item)),
                            });
                            break;
                        case CONSTANT.code.TEXT_LENGTH_INCORRECT:
                            errorMessage = SETTING.messages.GROUP_ROOM_NAME_INVALID();
                            break;
                        case CONSTANT.code.ALREADY_EXISTED:
                            errorMessage = SETTING.messages.GROUP_ROOM_NAME_ALREADY_EXISTED();
                            break;
                        case CONSTANT.code.COUNT_EXCEED:
                            errorMessage = SETTING.messages.GROUP_ROOM_COUNT_EXCEED();
                            break;
                        default:
                            errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.ADD_GROUP_ROOM);
                            console.log(`[${actionTypes.CHAT_ADD_GROUP_ROOM}] result code ${code}`);
                            break;
                    }
                } catch (err) {
                    console.error(err);
                    errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.ADD_GROUP_ROOM);
                }
            }

            return errorMessage;
        });

        this[actionTypes.CHAT_REMOVE_GROUP_ROOM] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;

            let errorMessage;
            try {
                let result = await signalr.chatServer.removeGroupRoom({ RoomId: roomId });
                let code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        break;
                    case CONSTANT.code.NOT_FOUND:
                        errorMessage = SETTING.messages.REMOVE_GROUP_ROOM_NOT_FOUND();
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.REMOVE_GROUP_ROOM);
                        console.log(`[${actionTypes.CHAT_REMOVE_GROUP_ROOM}] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.REMOVE_GROUP_ROOM);
            }

            return errorMessage;
        });

        this[actionTypes.CHAT_SET_GROUP_ROOM_NAME] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;
            let roomName = payload.roomName.trim();

            let errorMessage;
            errorMessage = this.checkGroupRoomNameLength(roomName);
            if (!errorMessage) {
                try {
                    let result = await signalr.chatServer.setGroupRoomName({ RoomId: roomId, Name: roomName });
                    let code = result.Code;
                    switch (code) {
                        case CONSTANT.code.SUCCESS:
                            break;
                        case CONSTANT.code.TEXT_LENGTH_INCORRECT:
                            errorMessage = SETTING.messages.GROUP_ROOM_NAME_INVALID();
                            break;
                        case CONSTANT.code.ALREADY_EXISTED:
                            errorMessage = SETTING.messages.GROUP_ROOM_NAME_ALREADY_EXISTED();
                            break;
                        case CONSTANT.code.NOT_FOUND:
                            errorMessage = SETTING.messages.REMOVE_GROUP_ROOM_NOT_FOUND();
                            break;
                        default:
                            errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SET_GROUP_ROOM_NAME);
                            console.log(`[${actionTypes.CHAT_SET_GROUP_ROOM_NAME}] result code ${code}`);
                            break;
                    }
                } catch (err) {
                    console.error(err);
                    errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SET_GROUP_ROOM_NAME);
                }
            }

            return errorMessage;
        });

        this[actionTypes.CHAT_ADD_GROUP_ROOM_MEMBER] = this.checkConnectionAsyncAction(async (context, payload) => {
            let builder = new GroupRoomMemberRequestBuilder(payload.builder);
            let errorMessage;

            // 檢查是否是自己的下級成員
            builder.getAllMemberLoginIds().every((item) => {
                let member = this.getDescendantMember(context, item);
                if (member) {
                    // 加入userId 檢查是否在群組內的時候會用到
                    builder.appendMemberUserId(item, member.userId);
                    return true;
                } else {
                    errorMessage = SETTING.messages.ADD_GROUP_ROOM_MEMBER_MEMBER_NOT_EXISTED();
                    return false;
                }
            });

            // 檢查如果已存在群組內就不執行
            if (!errorMessage) {
                errorMessage = this.checkMemberInGroupRoom(context, builder);
            }

            if (!errorMessage) {
                try {
                    let result = await signalr.chatServer.addGroupRoomMember({ Rooms: builder.toServerFormat() });
                    let code = result.Code;
                    switch (code) {
                        case CONSTANT.code.SUCCESS:
                            break;
                        case CONSTANT.code.SIZE_EXCEED:
                            errorMessage = SETTING.messages.ADD_GROUP_ROOM_MEMBER_MODIFIED_ROOM_COUNT_EXCEED();
                            break;
                        case CONSTANT.code.NOT_FOUND:
                            errorMessage = SETTING.messages.ADD_GROUP_ROOM_MEMBER_ROOM_NOT_FOUND();
                            break;
                        case CONSTANT.code.FORBID:
                            errorMessage = SETTING.messages.ADD_GROUP_ROOM_MEMBER_ROOM_FOBID();
                            break;
                        case CONSTANT.code.MEMBER_NOT_EXISTED:
                            errorMessage = SETTING.messages.ADD_GROUP_ROOM_MEMBER_MEMBER_NOT_EXISTED();
                            break;
                        case CONSTANT.code.COUNT_EXCEED:
                            errorMessage = SETTING.messages.GROUP_ROOM_COUNT_EXCEED();
                            break;
                        default:
                            errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_ADD_GROUP_ROOM_MEMBER);
                            console.log(`[${actionTypes.CHAT_ADD_GROUP_ROOM_MEMBER}] result code ${code}`);
                            break;
                    }
                } catch (err) {
                    console.error(err);
                    errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_ADD_GROUP_ROOM_MEMBER);
                }
            }

            return errorMessage;
        });

        this[actionTypes.CHAT_REMOVE_GROUP_ROOM_MEMBER] = this.checkConnectionAsyncAction(async (context, payload) => {
            let builder = new GroupRoomMemberRequestBuilder(payload.builder);
            let errorMessage;

            // 檢查是否是群組的成員
            // 送出的資料加上userId
            builder.getRoomIds().some((r) => {
                builder.getRoomMemberLoingIds(r).some((m) => {
                    let member = this.getRoomMember(context, r, m);
                    if (member) {
                        builder.appendMemberUserId(m, member.userId);
                    } else {
                        errorMessage = SETTING.messages.REMOVE_GROUP_ROOM_MEMBER_MEMBER_NOT_EXISTED();
                    }
                    return errorMessage;
                });
                return errorMessage;
            });

            if (!errorMessage) {
                try {
                    let result = await signalr.chatServer.removeGroupRoomMember({ Rooms: builder.toServerFormat() });
                    let code = result.Code;
                    switch (code) {
                        case CONSTANT.code.SUCCESS:
                            break;
                        case CONSTANT.code.SIZE_EXCEED:
                            errorMessage = SETTING.messages.REMOVE_GROUP_ROOM_MEMBER_MODIFIED_ROOM_COUNT_EXCEED();
                            break;
                        case CONSTANT.code.NOT_FOUND:
                            errorMessage = SETTING.messages.REMOVE_GROUP_ROOM_MEMBER_ROOM_NOT_FOUND();
                            break;
                        case CONSTANT.code.FORBID:
                            errorMessage = SETTING.messages.REMOVE_GROUP_ROOM_MEMBER_FOBID();
                            break;
                        default:
                            errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_REMOVE_GROUP_ROOM_MEMBER);
                            console.log(`[${actionTypes.CHAT_REMOVE_GROUP_ROOM_MEMBER}] result code ${code}`);
                            break;
                    }
                } catch (err) {
                    console.error(err);
                    errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_REMOVE_GROUP_ROOM_MEMBER);
                }
            }

            return errorMessage;
        });

        this[actionTypes.CHAT_SET_HISTORY_MESSAGE_CLEAR_TIME] = async (context, payload) => {
            let roomId = payload.roomId;

            let errorMessage;
            try {
                let result = await signalr.chatServer.setHistoryMessageClearTime({ RoomId: roomId });
                let code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        break;
                    case CONSTANT.code.FORBID:
                        errorMessage = SETTING.messages.FORBID(SETTING.functionNames.CLEAR_HISTORY_MESSAGE);
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CLEAR_HISTORY_MESSAGE);
                        console.log(`[${actionTypes.CHAT_SET_HISTORY_MESSAGE_CLEAR_TIME}] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CLEAR_HISTORY_MESSAGE);
            }
            if (errorMessage) {
                context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                    roomId: roomId,
                    type: CONSTANT.messageType.WARNING,
                    content: errorMessage,
                });
            }
        };

        this[actionTypes.CHAT_RECEIVE_HISTORY_MESSAGE_CLEAR_TIME] = async (context, payload) => {
            let roomId = payload.roomId;
            let timestamp = payload.timestamp;

            // 清除訊息
            context.commit(mutationTypes.CHAT_REMOVE_ROOM_MESSAGE_BY_CLEAR_TIME, {
                roomId: roomId,
                timestamp: timestamp,
            });

            // 設定清除時間
            context.commit(mutationTypes.CHAT_UPDATE_MESSAGE_CLEAR_TIME, {
                roomId: roomId,
                timestamp: timestamp,
            });
        };

        this[actionTypes.CHAT_CHECK_UPLOAD_IMAGE_LIMIT] = async (context, payload) => {
            let roomId = payload.roomId;
            let files = payload.files;

            let errorMessage = this.checkUploadImageLimit(files);

            if (errorMessage) {
                context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                    roomId: roomId,
                    type: CONSTANT.messageType.WARNING,
                    content: errorMessage,
                });
                return false;
            }

            return true;
        };

        // anonymity
        this[actionTypes.CHAT_ANONYMITY_INIT] = async (context, payload) => {
            let roomId = payload.roomId;

            // 建立訊息儲存區
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE_CONTAINER, { roomId: roomId });

            // 開啟視窗
            context.commit(mutationTypes.CHAT_ADD_ROOM_WINDOW, { roomId: roomId });
            context.commit(mutationTypes.CHAT_OPEN_ROOM_WINDOW, { roomId: roomId });

            // 顯示歡迎語
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                roomId: roomId,
                type: CONSTANT.messageType.INFO,
                content: SETTING.messages.ANONYMITY_WELCOME(),
            });
        };

        this[actionTypes.CHAT_ANONYMITY_SEND_MESSAGE] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;
            let type = payload.type;
            let content = payload.content;

            if (!this.checkMessageSendInterval(context, roomId, type)
                || !this.checkMessageContentSize(context, roomId, content)) {
                return false;
            }

            let message = {
                RoomId: roomId,
                Type: type,
                Content: content,
            };

            let errorMessage;
            try {
                let result = await signalr.chatServer.addMessageAnonymity(message);
                let code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        break;
                    case CONSTANT.code.FORBID:
                        errorMessage = SETTING.messages.ANONYMITY_ROOM_DATA_NOT_FOUND();
                        break;
                    case CONSTANT.code.TEXT_LENGTH_INCORRECT:
                        errorMessage = SETTING.messages.MESSAGE_SEND_CONTENT_INVALID();
                        break;
                    case CONSTANT.code.CUSTOMER_SERVICE_CHAT_NOT_INIT:
                        errorMessage = SETTING.messages.CUSTOMER_SERVICE_CHAT_NOT_INIT_ON_ANONYMITY();
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SEND_MESSAGE);
                        console.log(`[sendMessage] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SEND_MESSAGE);
            }

            if (errorMessage) {
                context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                    roomId: roomId,
                    type: CONSTANT.messageType.WARNING,
                    content: errorMessage,
                });
            }
        });

        this[actionTypes.CHAT_SYSTEM_MESSAGE] = async (context, payload) => {
            let roomId = payload.roomId;

            // 未讀訊息歸0
            context.commit(mutationTypes.CHAT_INCREMENT_UNREAD_NUMBER, { roomId: roomId, count: 0 });

            // 更新房間時間
            this.updateRoomActiveTime(context, roomId, true);
        };

        //群組集體禁言
        this[actionTypes.CHAT_UPDATE_GROUP_ROOM_READONLY] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;
            let isReadOnly = payload.isReadOnly;

            let errorMessage;
            try {
                let result = await signalr.chatServer.updateGroupRoomReadOnly({ RoomId: roomId, IsReadOnly: isReadOnly });
                let code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        break;
                    case CONSTANT.code.NOT_FOUND:
                        errorMessage = SETTING.messages.UPDATE_GROUP_ROOM_READONLY_ROOM_NOT_FOUND();
                        break;
                    case CONSTANT.code.FORBID:
                        errorMessage = SETTING.messages.UPDATE_GROUP_ROOM_READONLY_FOBID();
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_UPDATE_GROUP_ROOM_READONLY);
                        console.log(`[${actionTypes.CHAT_UPDATE_GROUP_ROOM_READONLY}] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_UPDATE_GROUP_ROOM_READONLY);
            }
            return errorMessage;
        });

        //群組可選多個玩家同時禁言
        this[actionTypes.CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY] = this.checkConnectionAsyncAction(async (context, payload) => {
            let builder = new GroupRoomMemberRequestBuilder(payload.builder);
            let errorMessage;

            // 檢查是否是群組的成員
            // 送出的資料加上userId
            builder.getRoomIds().some((r) => {
                builder.getRoomMemberLoingIds(r).some((m) => {
                    let member = this.getRoomMember(context, r, m);
                    if (member) {
                        builder.appendMemberUserId(m, member.userId);
                    } else {
                        errorMessage = SETTING.messages.UPDATE_GROUP_ROOM_MEMBER_READONLY_MEMBER_NOT_EXISTED();
                    }
                    return errorMessage;
                });
                return errorMessage;
            });

            if (!errorMessage) {
                try {
                    //禁言只會對同一個群組，所以取builder.toServerFormat()[0] 不會同時改多個
                    let result = await signalr.chatServer.updateGroupRoomMemberReadOnly({ Room: builder.toServerFormat()[0] });
                    let code = result.Code;
                    switch (code) {
                        case CONSTANT.code.SUCCESS:
                            break;
                        case CONSTANT.code.NOT_FOUND:
                            errorMessage = SETTING.messages.UPDATE_GROUP_ROOM_MEMBER_READONLY_ROOM_NOT_FOUND();
                            break;
                        case CONSTANT.code.FORBID:
                            errorMessage = SETTING.messages.UPDATE_GROUP_ROOM_MEMBER_READONLY_FOBID();
                            break;
                        default:
                            errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY);
                            console.log(`[${actionTypes.CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY}] result code ${code}`);
                            break;
                    }
                } catch (err) {
                    console.error(err);
                    errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY);
                }
            }

            return errorMessage;
        });

        //群組公告設置
        this[actionTypes.CHAT_SET_GROUP_ROOM_ANNOUNCEMENT] = async (context, payload) => {
            let roomIds = payload.roomIds;
            let announcement = payload.announcement;

            let errorMessage;
            if (!announcement) {
                errorMessage =  SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_EMPTY();
            } else if (announcement.length > SETTING.ANNOUNCEMENT_MAX_SIZE) {
                errorMessage = SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_MAX_SIZE(SETTING.ANNOUNCEMENT_MAX_SIZE);
            }

            if (!errorMessage) {
                try {
                    let result = await signalr.chatServer.setGroupRoomAnnouncement({ RoomIds: roomIds, Announcement: announcement });
                    let code = result.Code;
                    switch (code) {
                        case CONSTANT.code.SUCCESS:
                            break;
                        case CONSTANT.code.TEXT_LENGTH_INCORRECT:
                            errorMessage = SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_TOO_LONG();
                            break;
                        case CONSTANT.code.NOT_FOUND:
                            errorMessage = SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_ROOM_NOT_FOUND();
                            break;
                        case CONSTANT.code.FORBID:
                            errorMessage = SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_FOBID();
                            break;
                        default:
                            errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_SET_GROUP_ROOM_ANNOUNCEMENT);
                            console.log(`[${actionTypes.CHAT_SET_GROUP_ROOM_ANNOUNCEMENT}] result code ${code}`);
                            break;
                    }
                } catch (err) {
                    console.error(err);
                    errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_SET_GROUP_ROOM_ANNOUNCEMENT);
                }
            }
            
            return errorMessage;
        };

        //群組公告 - 新增
        this[actionTypes.CHAT_ADD_JSON_GROUP_ROOM_ANNOUNCEMENT] = async (context, payload) => {
            let roomId = payload.roomId;
            let content = payload.content;

            if (!roomId) {
                return SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_ROOM_NOT_FOUND();
            }

            if (!content) {
                return SETTING.messages.JSON_GROUP_ROOM_ANNOUNCEMENT_EMPTY();
            }

            let errorMessage;
            try {
                let result = await signalr.chatServer.addGroupRoomAnnouncementByJSON({ RoomId: roomId, Content: content });
                let code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        break;
                    case CONSTANT.code.TEXT_LENGTH_INCORRECT:
                        errorMessage = SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_TOO_LONG();
                        break;
                    case CONSTANT.code.FORBID:
                        errorMessage = SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_FOBID();
                        break;
                    case CONSTANT.code.COUNT_EXCEED:
                        errorMessage = SETTING.messages.JSON_GROUP_ROOM_ANNOUNCEMENT_COUNT_EXCEED();
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_ADD_JSON_GROUP_ROOM_ANNOUNCEMENT);
                        console.log(`[${actionTypes.CHAT_ADD_JSON_GROUP_ROOM_ANNOUNCEMENT}] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_ADD_JSON_GROUP_ROOM_ANNOUNCEMENT);
            }
            return errorMessage;
        };

        //群組公告 - 刪除
        this[actionTypes.CHAT_REMOVE_JSON_GROUP_ROOM_ANNOUNCEMENT] = async (context, payload) => {
            let roomId = payload.roomId;
            let removeIds = payload.removeIds;

            if (!roomId) {
                return SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_ROOM_NOT_FOUND();
            }

            if (!removeIds || removeIds.length == 0) {
                return SETTING.messages.JSON_GROUP_ROOM_ANNOUNCEMENT_RMOVE_ID_EMPTY();
            }

            let errorMessage;
            try {
                let result = await signalr.chatServer.removeGroupRoomAnnouncementByJSON({ RoomId: roomId, RemoveIds: removeIds });
                let code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        break;
                    case CONSTANT.code.FORBID:
                        errorMessage = SETTING.messages.SET_GROUP_ROOM_ANNOUNCEMENT_FOBID();
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_REMOVE_JSON_GROUP_ROOM_ANNOUNCEMENT);
                        console.log(`[${actionTypes.CHAT_REMOVE_JSON_GROUP_ROOM_ANNOUNCEMENT}] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_REMOVE_JSON_GROUP_ROOM_ANNOUNCEMENT);
            }
            return errorMessage;
        };

        //群組變更成員權限 (管理者、群組)
        this[actionTypes.CHAT_SET_GROUP_ROOM_MEMBER_ROLE] = async (context, payload) => {
            let builder = new GroupRoomMemberRequestBuilder(payload.builder);
            let errorMessage;

            // 檢查是否是群組的成員
            // 送出的資料加上userId
            builder.getRoomIds().some((r) => {
                builder.getRoomMemberLoingIds(r).some((m) => {
                    let member = this.getRoomMember(context, r, m);
                    if (member) {
                        builder.appendMemberUserId(m, member.userId);
                    } else {
                        errorMessage = SETTING.messages.SET_GROUP_ROOM_MEMBER_ROLE_MEMBER_NOT_EXISTED();
                    }
                    return errorMessage;
                });
                return errorMessage;
            });

            if (!errorMessage) {
                try {
                    //權限只會對同一個群組的組員做變更，不會同時對不同群組變更組員權限，所以取builder.toServerFormat()[0] 不會同時改多個
                    let result = await signalr.chatServer.setGroupRoomMemberRole({ Room: builder.toServerFormat()[0] });
                    let code = result.Code;
                    switch (code) {
                        case CONSTANT.code.SUCCESS:
                            break;
                        case CONSTANT.code.NOT_FOUND:
                            errorMessage = SETTING.messages.SET_GROUP_ROOM_MEMBER_ROLE_ROOM_NOT_FOUND();
                            break;
                        case CONSTANT.code.FORBID:
                            errorMessage = SETTING.messages.SET_GROUP_ROOM_MEMBER_ROLE_FOBID();
                            break;
                        default:
                            errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CHAT_SET_GROUP_ROOM_MEMBER_ROLE);
                            console.log(`[${actionTypes.CHAT_SET_GROUP_ROOM_MEMBER_ROLE}] result code ${code}`);
                            break;
                    }
                } catch (err) {
                    console.error(err);
                    errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CHAT_SET_GROUP_ROOM_MEMBER_ROLE);
                }
            }

            return errorMessage;
        };

        //客服評分系統
        this[actionTypes.CHAT_CUSTOMER_SERVICE_RATING] = async (context, payload) => {
            let sessionId = payload.sessionId;
            let isAlreadyRating = payload.isAlreadyRating;
            let content = payload.content;
            let score = payload.score;

            if (!sessionId) {
                return SETTING.messages.SET_CUSTOMER_SERVICE_RATING_NOT_SESSION_ID();
            }

            if (isAlreadyRating) {
                return SETTING.messages.SET_CUSTOMER_SERVICE_RATING_EXISTED();
            }

            if (!sessionId) {
                return SETTING.messages.SET_CUSTOMER_SERVICE_RATING_NOT_SESSION_ID();
            }

            if (content.length > SETTING.CUSTOMER_SERVICE_RATING_CONTENT_MAX_SIZE) {
                return SETTING.messages.SET_CUSTOMER_SERVICE_RATING_CONTENT_MAX_SIZE(SETTING.CUSTOMER_SERVICE_RATING_CONTENT_MAX_SIZE);
            }

            let errorMessage;
            try {
                let result = await signalr.chatServer.setCustomerServiceRating({ SessionId: sessionId, Content: content, Score: score });
                let code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        break;
                    case CONSTANT.code.SIZE_EXCEED:
                        errorMessage = SETTING.messages.SET_CUSTOMER_SERVICE_RATING_CONTENT_MAX_SIZE(SETTING.CUSTOMER_SERVICE_RATING_CONTENT_MAX_SIZE);
                        break;
                    case CONSTANT.code.ALREADY_EXISTED:
                        errorMessage = SETTING.messages.SET_CUSTOMER_SERVICE_RATING_EXISTED();
                        break;
                    case CONSTANT.code.NOT_FOUND:
                        errorMessage = SETTING.messages.SET_CUSTOMER_SERVICE_RATING_NOT_EXISTED();
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.CUSTOMER_SERVICE_RATING);
                        console.log(`[${actionTypes.CHAT_CUSTOMER_SERVICE_RATING}] result code ${code}`);
                        break;
                }

                //已經評分過更改狀態
                if (code == CONSTANT.code.ALREADY_EXISTED || code == CONSTANT.code.SUCCESS) {
                    context.commit(mutationTypes.CHAT_SET_CUSTOMER_SERVICE_SESSION_ID, { sessionId: sessionId, isAlreadyRating: true });
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.CUSTOMER_SERVICE_RATING);
            }
            return errorMessage;
        };

        //更新mobile dialog page name 和 data參數
        this[actionTypes.CHAT_UPDATE_MOBILE_DIALOG_NAME_AND_DATA] = async (context, payload) => {
            let pageName = payload.pageName;
            let data = payload.data;
            context.commit(mutationTypes.CHAT_UPDATE_DIALOG_PAGE_NAME_AND_DATA, {
                pageName: pageName,
                data: data
            });
        };

        // 進入全站群聊房間
        this[actionTypes.CHAT_SITE_GROUP_ENTER_ROOM] = this.checkConnectionAsyncAction(async (context, payload) => {
            let errorMessage;
            try {
                const roomId = payload.roomId;
                const password = payload.password;
                const result = await signalr.chatServer.enterSiteGroupRoom({
                    RoomId: roomId,
                    Password: password,
                });
                const code = result.Code;
                
                switch (code) {
                    case CONSTANT.code.SUCCESS: {
                        // 儲存群聊房間的 session token
                        storage.session.set(storage.keys.CHAT_SITE_GROUP_SESSION_TOKEN, result.SessionToken);

                        // 移除上一個群聊
                        if (context.state.siteGroupRoom) {
                            const roomId = context.state.siteGroupRoom.room.id; 
                            context.commit(mutationTypes.CHAT_REMOVE_ROOM_WINDOW, { roomId });
                            context.commit(mutationTypes.CHAT_REMOVE_ROOM_MESSAGE_CONTAINER, { roomId });
                        }
                        
                        // 更新 site group room 資料
                        context.commit(mutationTypes.CHAT_SITE_GROUP_INIT_ROOM, { roomId, result });

                        // 開啟聊天視窗
                        await context.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                            roomId: roomId,
                            siteGroupSystemMessage: result.SystemMessage
                        })

                        break;
                    }
                    case CONSTANT.code.COUNT_EXCEED:
                        errorMessage = SETTING.messages.SITE_GROUP_COUNT_EXCEED();
                        break;
                    case CONSTANT.code.VIP_LEVEL_NOT_MATCH:
                        errorMessage = SETTING.messages.SITE_GROUP_VIP_LEVEL_NOT_MATCH();
                        break;
                    case CONSTANT.code.PASSWORD_INCORRECT:
                        errorMessage = SETTING.messages.SITE_GROUP_PASSWORD_INCORRECT();
                        break;
                    case CONSTANT.code.DAILY_DEPOSIT_NOT_ENOUGH:
                        errorMessage = SETTING.messages.SITE_GROUP_DAILY_DEPOSIT_NOT_ENOUGH(result.InsufficientAmount);
                        break;
                    case CONSTANT.code.DAILY_BET_NOT_ENOUGH: {
                        const groupRoomDailyBetType = LotteryConstant.ChatSiteGroupRoomDailyBetType;
                        const dailyBetType = result.DailyBetType;
                        const insufficientAmount = result.InsufficientAmount;
                        if (dailyBetType === groupRoomDailyBetType.LOTTERY) {
                            errorMessage = SETTING.messages.SITE_GROUP_DAILY_BET_NOT_ENOUGH_LOTTERY(insufficientAmount);
                        } else if (dailyBetType === groupRoomDailyBetType.EXTERNAL_GAME) {
                            errorMessage = SETTING.messages.SITE_GROUP_DAILY_BET_NOT_ENOUGH_EXTERNAL_GAME(insufficientAmount);
                        } else if (dailyBetType === groupRoomDailyBetType.LOTTERY_AND_EXTERNAL_GAME) {
                            errorMessage = SETTING.messages.SITE_GROUP_DAILY_BET_NOT_ENOUGH_LOTTERY_AND_EXTERNAL_GAME(insufficientAmount);
                        }
                        break;
                    }
                    default:
                        errorMessage =  SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.ENTRY_SITE_GROUP_ROOM);
                        break;
                }
            } catch (err) {
                errorMessage =  SETTING.messages.NETWORK_FAILED(SETTING.functionNames.ENTRY_SITE_GROUP_ROOM);
                console.error(err);
            }

            return errorMessage;
        });

        // 離開全站群聊房間
        this[actionTypes.CHAT_SITE_GROUP_LEAVE_ROOM] = async (context) => {
            if (context.state.siteGroupRoom) {
                const roomId = context.state.siteGroupRoom.room.id; 
                context.commit(mutationTypes.CHAT_REMOVE_ROOM_WINDOW, { roomId });
                context.commit(mutationTypes.CHAT_REMOVE_ROOM_MESSAGE_CONTAINER, { roomId });

                try {
                    // 通知server離開群聊，失敗會多收前一個聊天室的訊息，應該不受影響
                    await signalr.chatServer.leaveSiteGroupRoom({
                        RoomId: roomId,
                    });
                } catch (err) {
                    console.error(err);
                }
            }
        };

        // 更新全站群聊房間列表
        this[actionTypes.CHAT_SITE_GROUP_UPDATE_ROOMS] = this.checkConnectionAsyncAction(async (context, payload) => {
            try {
                const result = await signalr.chatServer.getSiteGroupRooms();
                const code = result.Code;
                const rooms = result.Rooms;
                if (code === CONSTANT.code.SUCCESS) {
                    // 刪除之前的全站群聊房間
                    context.state.rooms.forEach((room) => {
                        if (room.type === CONSTANT.roomType.SITE_GROUP) {
                            context.commit(mutationTypes.CHAT_REMOVE_ROOM, { roomId: room.id });
                        }
                    });
                    
                    // 新增全站群聊房間
                    rooms.forEach((room) => {
                        context.commit(mutationTypes.CHAT_ADD_ROOM, { room: transform.transformRoom(room) });
                    })
                }
            } catch (err) {
                console.error(err);
            }
        });

        // 加入群聊的導師聊天室
        this[actionTypes.CHAT_SITE_GROUP_ADD_TUTOR_ROOM] = async (context, payload) => {
            context.commit(mutationTypes.CHAT_ADD_ROOM, {
                room: new model.room({
                    id: payload.roomId,
                    type: CONSTANT.roomType.SITE_GROUP_TUTOR,
                    name: payload.name,
                    image: payload.headImage,
                }),
            });
        };

        // 刪除全站群聊訊息
        this[actionTypes.CHAT_SITE_GROUP_REMOVE_MESSAGE] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;
            let messageId = payload.messageId;

            const messageContainer = context.state.roomMessageContainers
                .find((item) => item.room.id === roomId);
            if (!messageContainer) {
                return SETTING.messages.SITE_GROUP_REMOVE_MESSAGE_NOT_FOUND();
            }

            const message = messageContainer.roomMessages.find((item) => item.messageId === messageId);
            if (!message) {
                return SETTING.messages.SITE_GROUP_REMOVE_MESSAGE_NOT_FOUND();
            }

            try {
                let result = await signalr.chatServer.removeSiteGroupMessage({
                    RoomId: roomId,
                    MessageId: messageId,
                    Timestamp: message.timestamp,
                });

                const code = result.Code;

                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        return SETTING.messages.SITE_GROUP_REMOVE_MESSAGE_SUCCESS();
                    case CONSTANT.code.FORBID:
                        return SETTING.messages.SITE_GROUP_REMOVE_MESSAGE_FORBID();
                    default:
                        return SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_REMOVE_MESSAGE);
                } 
            }
            catch (err) {
                return SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SITE_GROUP_REMOVE_MESSAGE);
            }
        });

        // 取得全站群聊訊息會員資訊
        this[actionTypes.CHAT_SITE_GROUP_GET_MESSAGE_USER_INFO] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;
            let messageId = payload.messageId;

            const messageContainer = context.state.roomMessageContainers
                .find((item) => item.room.id === roomId);
            if (!messageContainer) {
                return { errorMessage: SETTING.messages.SITE_GROUP_GET_MESSAGE_USER_INFO_NOT_FOUND() };
            }

            const message = messageContainer.roomMessages.find((item) => item.messageId === messageId);
            if (!message) {
                return { errorMessage: SETTING.messages.SITE_GROUP_GET_MESSAGE_USER_INFO_NOT_FOUND() };
            }

            try {
                let result = await signalr.chatServer.getSiteGroupMessageUserInfo({
                    RoomId: roomId,
                    MessageId: messageId,
                    Timestamp: message.timestamp,
                });

                const code = result.Code;

                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        return {
                            loginId: result.LoginId,
                            nickName: result.NickName,
                            headImage: result.HeadImage,
                        };
                    case CONSTANT.code.FORBID:
                        return { errorMessage: SETTING.messages.SITE_GROUP_GET_MESSAGE_USER_INFO_FORBID() };
                    case CONSTANT.code.NOT_FOUND:
                        return { errorMessage: SETTING.messages.SITE_GROUP_GET_MESSAGE_USER_INFO_NOT_FOUND() };
                    default:
                        return { errorMessage: SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_GET_MESSAGE_USER_INFO) };
                } 
            }
            catch (err) {
                return { errorMessage: SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SITE_GROUP_GET_MESSAGE_USER_INFO) };
            }
        });

        // 全站群聊玩家禁言
        this[actionTypes.CHAT_SITE_GROUP_UPDATE_MEMBER_READONLY] = this.checkConnectionAsyncAction(async (context, payload) => {
            let resultMessage;
            let roomId = payload.roomId;
            let messageId = payload.messageId;

            const messageContainer = context.state.roomMessageContainers
                .find((item) => item.room.id === roomId);
            if (!messageContainer) {
                return SETTING.messages.SITE_GROUP_UPDATE_MEMBER_READONLY_NOT_FOUND();
            }

            const message = messageContainer.roomMessages.find((item) => item.messageId === messageId);
            if (!message) {
                return SETTING.messages.SITE_GROUP_UPDATE_MEMBER_READONLY_NOT_FOUND();
            }

            try {
                let result = await signalr.chatServer.updateSiteGroupMemberReadOnly({ 
                    RoomId: roomId,
                    MessageId: messageId,
                    Timestamp: message.timestamp,
                });

                const code = result.Code;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        resultMessage = SETTING.messages.SITE_GROUP_UPDATE_MEMBER_READONLY_SUCCESS();
                        break;
                    case CONSTANT.code.ALREADY_EXISTED:
                        resultMessage = SETTING.messages.SITE_GROUP_UPDATE_MEMBER_READONLY_ALREADY_EXISTED();
                        break;
                    case CONSTANT.code.FORBID:
                        resultMessage = SETTING.messages.SITE_GROUP_UPDATE_MEMBER_READONLY_FOBID();
                        break;
                    case CONSTANT.code.NOT_FOUND:
                        resultMessage = SETTING.messages.SITE_GROUP_UPDATE_MEMBER_READONLY_NOT_FOUND();
                        break;
                    case CONSTANT.code.MEMBER_NOT_EXISTED:
                        resultMessage = SETTING.messages.SITE_GROUP_UPDATE_MEMBER_READONLY_NOT_EXISTED();
                        break;
                    default:
                        resultMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_UPDATE_MEMBER_READONLY);
                        console.log(`[${actionTypes.CHAT_SITE_GROUP_UPDATE_MEMBER_READONLY}] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                resultMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SITE_GROUP_UPDATE_MEMBER_READONLY);
            }

            return resultMessage;
        });

        // 全站群聊清屏
        this[actionTypes.CHAT_SITE_GROUP_CLEAR_MESSAGE] = this.checkConnectionAsyncAction(async (context, payload) => {
            const roomId = payload.roomId;
            try {
                let result = await signalr.chatServer.clearSiteGroupMessage({
                    RoomId: roomId,
                });

                const code = result.Code;

                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        return SETTING.messages.SITE_GROUP_CLEAR_MESSAGE_SUCCESS();
                    case CONSTANT.code.FORBID:
                        return SETTING.messages.SITE_GROUP_CLEAR_MESSAGE_FOBID();
                    default:
                        return SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_CLEAR_MESSAGE);
                } 
            }
            catch (err) {
                return SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_CLEAR_MESSAGE);
            }
        });

        // 全站群聊設定置頂訊息
        this[actionTypes.CHAT_SITE_GROUP_SET_PIN_MESSAGE] = this.checkConnectionAsyncAction(async (context, payload) => {
            let roomId = payload.roomId;
            let messageId = payload.messageId;

            const messageContainer = context.state.roomMessageContainers
                .find((item) => item.room.id === roomId);
            if (!messageContainer) {
                return SETTING.messages.SITE_GROUP_SET_PIN_MESSAGE_NOT_FOUND();
            }

            const message = messageContainer.roomMessages.find((item) => item.messageId === messageId);
            if (!message) {
                return SETTING.messages.SITE_GROUP_SET_PIN_MESSAGE_NOT_FOUND();
            }

            try {
                let result = await signalr.chatServer.setSiteGroupPinMessage({
                    RoomId: roomId,
                    MessageId: messageId
                });

                const code = result.Code;

                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        return SETTING.messages.SITE_GROUP_SET_PIN_MESSAGE_SUCCESS();
                    case CONSTANT.code.FORBID:
                        return SETTING.messages.SITE_GROUP_SET_PIN_MESSAGE_FOBID();
                    case CONSTANT.code.NOT_FOUND:
                        return SETTING.messages.SITE_GROUP_SET_PIN_MESSAGE_NOT_FOUND();
                    default:
                        return SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_SET_PIN_MESSAGE);
                } 
            }
            catch (err) {
                return SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_SET_PIN_MESSAGE);
            }
        });

        // 導師查詢會員資訊
        this[actionTypes.CHAT_SITE_GROUP_SEARCH_MEMBER] = this.checkConnectionAsyncAction(async (context, payload) => {
            try {
                let result = await signalr.chatServer.siteGroupTutorSearchMember({
                    RoomId: payload.roomId,
                    SearchLoginId: payload.searchLoginId,
                });

                const code = result.Code;

                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        return {
                            loginId: result.LoginId,
                            nickName: result.NickName,
                            headImage: result.HeadImage,
                            roomId: result.RoomId
                        };
                    case CONSTANT.code.FORBID:
                        return { errorMessage: SETTING.messages.SITE_GROUP_SEARCH_MEMBER_FORBID() };
                    case CONSTANT.code.MEMBER_NOT_EXISTED:
                        return { errorMessage: SETTING.messages.SITE_GROUP_SEARCH_MEMBER_NOT_EXISTED() };
                    default:
                        return { errorMessage: SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_SEARCH_MEMBER) };
                } 
            }
            catch (err) {
                return { errorMessage: SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SITE_GROUP_SEARCH_MEMBER) };
            }
        });

        // 全站群聊移除最近聊天的導師房間
        this[actionTypes.CHAT_SITE_GROUP_REMOVE_TUTOR_RECENT_ROOM] = this.checkConnectionAsyncAction(async (context, payload) => {
            try {
                const result = await signalr.chatServer.removeSiteGroupTutorRecentRoom({
                    RoomId: payload.roomId,
                });

                const code = result.Code;

                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        return;
                    default:
                        return { errorMessage: SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_REMOVE_TUTOR_RECENT_ROOM) };
                } 
            } catch (err) {
                return { errorMessage: SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SITE_GROUP_REMOVE_TUTOR_RECENT_ROOM) };
            }
        });

        // 全站群聊取得群聊聊天室會員清單
        this[actionTypes.CHAT_SITE_GROUP_GET_ROOM_MEMBER_LIST] = this.checkConnectionAsyncAction(async (context, payload) => {
            try {
                const result = await signalr.chatServer.getSiteGroupRoomMemberList({
                    RoomId: payload.roomId,
                });

                const code = result.Code;

                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        return { members: result.Members };
                    default:
                        return { errorMessage: SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SITE_GROUP_GET_ROOM_MEMBER_LIST) };
                } 
            } catch (err) {
                return { errorMessage: SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SITE_GROUP_GET_ROOM_MEMBER_LIST) };
            }
        });

        // 全站群聊確認導師訊息列表房間
        this[actionTypes.CHAT_SITE_GROUP_CHECK_TUTOR_MESSAGE_LIST_ROOM] = async (context) => {
            const roomRetentionDays = 1;
            context.state.rooms.forEach((room) => {
                if (room.type !== CONSTANT.roomType.SITE_GROUP_TUTOR) {
                    return;
                }
    
                if (!room.startTutorTalking) {
                    return;
                }
    
                const lastMessage = context.state.roomLastMessages.find((item) => item.room.id === room.id);
                if (!lastMessage) {
                    return;
                }
    
                // 超過設定天數沒有訊息就關閉導師對話 (一天是 24 * 60 * 60 * 1000 毫秒)
                if ((Date.now() - lastMessage.timestamp) / (24 * 60 * 60 * 1000) > roomRetentionDays) {
                    context.commit(mutationTypes.CHAT_SITE_GROUP_END_TUTOR_TALKING, { roomId: room.id })
                }
            });
        };
    }

    checkConnectionAsyncAction(actionFn) {
        return async (context, payload) => {
            if (payload && payload.connectionParams) {
                await this.checkConnection(context, payload.connectionParams)
            }
            return await actionFn.call(this, context, payload);
        };
    }

    async checkConnection(context, { waitConnected, loading }) {
        // 檢查此功能是否啟用
        if (!SETTING.ENABLE_CHECK_CONNECTION_BEFORE_ACTION) {
            return;
        }
        // 檢查是否要等待已連線成功
        if (!waitConnected) {
            return;
        }
        // 先檢查是否已連線成功，沒有就顯示loading
        if (context.state.isConnected) {
            return;
        }

        let loader;
        if (loading) {
            loader = loading.show();
        }

        // 等待連線成功
        // 等待時間最多30秒
        var count = 0;
        while (!context.state.isConnected && count < 300) {
            await this.sleep(100);
            count++;
        }

        if (loader) {
            loader.hide();
        }
    }

    checkMessageSendInterval(context, roomId, type) {
        if (type === CONSTANT.messageType.BET) {
            // 分享的注單不限制間隔時間
            return true;
        }

        let now = new Date();
        let room = context.state.rooms.find((item) => item.id === roomId);
        if (room) {
            if (room.messageSendTime) {
                let diff = Math.floor((now - room.messageSendTime) / 1000);
                if (diff < SETTING.MESSAGE_SEND_INTERVAL_THRESHOLD) {
                    context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                        roomId: roomId,
                        type: CONSTANT.messageType.WARNING,
                        content: SETTING.messages.MESSAGE_SEND_INTERVAL_TOO_SHORT(),
                    });
                    return false;
                }
            }

            context.commit(mutationTypes.CHAT_UPDATE_ROOM_MESSAGE_SEND_TIME, {
                roomId: roomId,
                timestamp: now,
            });
            return true;
        }
        return false;
    }

    checkMessageContentSize(context, roomId, content) {
        var errorMessage;
        if (!content || content.length == 0) {
            errorMessage = SETTING.messages.MESSAGE_SEND_CONTENT_IS_EMPTY();
        } else if (content.length > SETTING.MESSAGE_CONTENT_MAX_SIZE) {
            errorMessage = SETTING.messages.MESSAGE_SEND_CONTENT_TOO_LONG();
        }

        if (errorMessage) {
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                roomId: roomId,
                type: CONSTANT.messageType.WARNING,
                content: errorMessage,
            });
            return false;
        }
        return true;
    }

    async sendMessage(context, roomId, type, content) {
        let errorMessage;
        try {
            if (!this.checkMessageSendInterval(context, roomId, type)
                || !this.checkMessageContentSize(context, roomId, content)) {
                return;
            }

            let message = {
                RoomId: roomId,
                Type: type,
                Content: content,
                NickName: context.state.nickName,
            };

            let result = await signalr.chatServer.addMessage(message);
            let code = result.Code;
            errorMessage = this.getSendMessageErrorMessage(context, roomId, code);
        } catch (err) {
            console.error(err);
            errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SEND_MESSAGE);
        }

        if (errorMessage) {
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                roomId: roomId,
                type: CONSTANT.messageType.WARNING,
                content: errorMessage,
            });
        }
    }

    async sendMessageMulticast(context, roomIds, type, content) {
        let errorMessages = [];
        try {
            roomIds.forEach((item) => {
                if (!this.checkMessageSendInterval(context, item, type)
                    || !this.checkMessageContentSize(context, item, content)) {
                    return false;
                }
            });
            //因超過900個下級一次發送可能會達到傳送大小上限, 改為每500個傳送一次
            let chunkRoomIds = this.splitRoomIds(roomIds.slice(0), 500);
            for (const eChunkRoomId of chunkRoomIds){
                let message = {
                    RoomIds: eChunkRoomId,
                    Type: type,
                    Content: content,
                    NickName: context.state.nickName,
                };
    
                let result = await signalr.chatServer.addMessageMulticast(message);
                result.roomResults.forEach((item) => {
                    let roomId = item.RoomId;
                    let code = item.Code;
                    let room = context.state.rooms.find((item) => item.id === roomId);
                    let message = this.getSendMessageErrorMessage(context, roomId, code);
                    let m = this.generateMessageMulticastErrorMessage(room, message);
                    if (m) {
                        errorMessages.push(m);
                    }
                });
            }
        } catch (err) {
            console.error(err);
            errorMessages.push(SETTING.messages.NETWORK_FAILED(SETTING.functionNames.SEND_MESSAGE));
        }

        return errorMessages;
    }

    splitRoomIds(roomIds, eachLength) {
        const result = [];
        while (roomIds.length) {
            result.push(roomIds.splice(0, eachLength));
        }
        return result;
    }

    getSendMessageErrorMessage(context, roomId, code) {
        switch (code) {
            case CONSTANT.code.SUCCESS:
                return undefined;
            case CONSTANT.code.FORBID:
                return SETTING.messages.FORBID(SETTING.functionNames.SEND_MESSAGE);
            case CONSTANT.code.TEXT_LENGTH_INCORRECT:
                return SETTING.messages.MESSAGE_SEND_CONTENT_INVALID();
            case CONSTANT.code.CUSTOMER_SERVICE_CHAT_NOT_INIT:
                // NOTICE: 如果之後這邊流程要改, 就把這部分的code包一個function然後覆寫
                context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                    roomId: roomId,
                    type: CONSTANT.messageType.CUSTOMER_SERVICE_QUESTION_LIST,
                    content: SETTING.messages.CUSTOMER_SERVICE_QUESTION_LIST(),
                });
                return SETTING.messages.CUSTOMER_SERVICE_CHAT_NOT_INIT();
            default:
                console.log(`[sendMessage] result code ${code}`);
                return SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.SEND_MESSAGE);
        }
    }

    generateMessageMulticastErrorMessage(room, message) {
        if (message) {
            return `${room.name}: ${message}`;
        }
    }

    checkUploadImageLimit(files) {
        if (files.length != SETTING.UPLOAD_IMAGE_MAX_COUNT) {
            return SETTING.messages.UPLOAD_IMAGE_COUNT_EXCEED();
        }

        //eslint-disable-next-line
        let fileNameExtenstionPattern = new RegExp("(\.|\/)(gif|jpe?g|png)$", "i");
        let sum = 0;
        for (let i = 0; i < files.length; i++) {
            sum += files[i].size;
            if (sum > SETTING.UPLOAD_IMAGE_MAX_SIZE) {
                return SETTING.messages.UPLOAD_IMAGE_SIZE_EXCEED();
            }
            else if (fileNameExtenstionPattern.test(files[i].name) == false) {
                return SETTING.messages.UPLOAD_IMAGE_NOT_ALLOW_TYPE();
            }
        }
    }

    closeRoomWindow(context, roomId) {
        context.commit(mutationTypes.CHAT_COLSE_ROOM_WINDOW, { roomId: roomId });
        this.updateRoomActiveTime(context, roomId, false);
    }

    closeActivedRoomWindow(context, roomId) {
        let room = context.state.rooms.find((item) => item.id === roomId);
        let number = SETTING.getWindowGroupNumber(room.type);
        context.state.roomWindows.forEach((item) => {
            if (item.showTime
                && SETTING.getWindowGroupNumber(item.room.type) === number
                && item.room.id !== roomId) {
                this.closeRoomWindow(context, item.room.id);
            }
        });
    }

    updateRoomActiveTime(context, roomId, isActive) {
        signalr.chatServer.updateRoomActiveTime({ RoomId: roomId, IsActive: isActive });
    }

    async loadGroupRoomMember(context, roomId) {
        let errorMessage;
        let memberContainer = context.state.roomMemberContainers.find((item) => item.room.id === roomId);
        if (memberContainer && memberContainer.room.type === CONSTANT.roomType.DESCENDANT_GROUP) {
            try {
                let result = await signalr.chatServer.getGroupRoomMember({ RoomId: roomId });
                let code = result.Code;
                let members = result.Members;
                switch (code) {
                    case CONSTANT.code.SUCCESS:
                        if (members) {
                            let groupMembers = context.state.excludeIsChatDenied ? members.filter(member => !member.IsChatDenied) : members;
                            for (let i = 0; i < groupMembers.length; i++) {
                                context.commit(mutationTypes.CHAT_ADD_ROOM_MEMBER, {
                                    roomId: roomId,
                                    member: transform.transformRoomMember(groupMembers[i]),
                                });
                            }
                        }
                        break;
                    case CONSTANT.code.FORBID:
                        errorMessage = SETTING.messages.GET_GROUP_ROOM_MEMBER_FORBID();
                        break;
                    default:
                        errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.LOAD_GROUP_ROOM_MEMBER);
                        console.log(`[loadGroupRoomMember] result code ${code}`);
                        break;
                }
            } catch (err) {
                console.error(err);
                errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.LOAD_GROUP_ROOM_MEMBER);
            }
            if (errorMessage) {
                context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                    roomId: roomId,
                    type: CONSTANT.messageType.WARNING,
                    content: errorMessage,
                });
            }
        }
    }

    async loadHistoryMessage(context, roomId) {
        let errorMessage;

        let messageContainer = context.state.roomMessageContainers.find((item) => item.room.id === roomId);
        if (!messageContainer) {
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE_CONTAINER, { roomId: roomId });
        }

        try {
            let result = await signalr.chatServer.getHistoryMessage({ RoomId: roomId });
            let code = result.Code;
            let messages = result.Messages;
            switch (code) {
                case CONSTANT.code.SUCCESS:
                    if (messages) {
                        for (let i = 0; i < messages.length; i++) {
                            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, transform.transformRoomMessage(messages[i]));
                        }
                    }
                    break;
                case CONSTANT.code.FORBID:
                    errorMessage = SETTING.messages.FORBID(SETTING.functionNames.LOAD_HISTORY_MESSAGE);
                    break;
                default:
                    errorMessage = SETTING.messages.SYSTEM_FAILED(SETTING.functionNames.LOAD_HISTORY_MESSAGE);
                    console.log(`[getHistoryMessage] result code ${code}`);
                    break;
            }
        } catch (err) {
            console.error(err);
            errorMessage = SETTING.messages.NETWORK_FAILED(SETTING.functionNames.LOAD_HISTORY_MESSAGE);
        }
        if (errorMessage) {
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                roomId: roomId,
                type: CONSTANT.messageType.WARNING,
                content: errorMessage,
            });
        }
    }

    async refreshRoomWindows(context) {
        // 判斷有開啟聊天室才檢查
        if (context.state.roomWindows.length > 0) {
            let removedRoomIds = [];
            for (let i = 0; i < context.state.roomWindows.length; i++) {
                let item = context.state.roomWindows[i];

                // 判斷全站群聊的聊天室是不是開啟中，因為群聊訊息區塊滾輪如果不是置底時，showTime 會是 undefined
                let siteGroupRoomOnTalking = false;
                if (context.state.siteGroupRoom) {
                    siteGroupRoomOnTalking = context.state.siteGroupRoom.room.id === item.room.id && context.state.siteGroupRoom.room.onTalkTime ? true : false;
                }
                
                if (item.showTime || siteGroupRoomOnTalking) {
                    // 目前是開啟的聊天室, 重新下載歷史訊息
                    await this.loadHistoryMessage(context, item.room.id);
                } else {
                    // 目前是關閉的聊天室, 移除視窗資訊, 之後點開會再觸發重新下載歷史訊息
                    removedRoomIds.push(item.room.id);
                }
            }
            removedRoomIds.forEach((id) => {
                context.commit(mutationTypes.CHAT_REMOVE_ROOM_WINDOW, { roomId: id });
                context.commit(mutationTypes.CHAT_REMOVE_ROOM_MESSAGE_CONTAINER, { roomId: id });
            });
        }
    }

    async reconnectedSync(context) {
        // 避免太頻繁斷線重拿資料，超過一段時間再拿資料
        const diffTime = new Date() - context.state.reconnectedSyncTime;
        const timeoutThreshold = 180000;
        if (diffTime < timeoutThreshold) {
            // 一定時間內不重複執行，有設定過timeout就不再設定
            if (!reconnectedSyncTimeout) {
                console.log("[" + new Date().toString() + "] " + "set reconnectedSyncTimeout");
                reconnectedSyncTimeout = setTimeout(async () => {
                    this.reconnectedSync(context);
                  }, timeoutThreshold - diffTime + 1000);
            }
            return;
        }
        // 清除timeout
        if (reconnectedSyncTimeout) {
            clearTimeout(reconnectedSyncTimeout);
            reconnectedSyncTimeout = undefined
        }

        // 檢查斷線時不做
        if (!context.state.isConnected) {
            return
        }

        console.log("[" + new Date().toString() + "] " + "start chat reconnected work");
        
        // 更新重新連線工作完成的時間，放在前面更新，避免短時間重複執行
        context.commit(mutationTypes.CHAT_UPDATE_RECONNECTED_SYNC_TIME);

        // 更新聊天室和未讀數量
        await this.reconnectedSyncFromServer(context);
    }

    async reconnectedSyncFromServer(context) {
        try {
            console.log("[" + new Date().toString() + "] " + "start chat reconnectedSyncFromServer");

            const result = await signalr.chatServer.syncWhenReconnected();
            const code = result.Code;
            const rooms = result.Rooms;
            if (code == CONSTANT.code.SUCCESS) {
                if (rooms && rooms.length > 0) {
                    for (let i = 0; i < rooms.length; i++) {
                        const room = rooms[i];

                        let existedRoom = context.state.rooms.find((item) => item.id === room.RoomId);
                        if (existedRoom) {
                            // 如果聊天室在store有存在
                            // 更新未讀訊息
                            context.commit(mutationTypes.CHAT_INCREMENT_UNREAD_NUMBER, { 
                                roomId: room.RoomId,
                                count: room.UnreadCount
                            });
                            // 更新最後的聊天訊息
                            if (room.LastMessage) {
                                var lastMessage = transform.transformRoomMessage(room.LastMessage);
                                context.commit(mutationTypes.CHAT_UPDATE_LAST_MESSAGE, {
                                    roomId: lastMessage.roomId,
                                    userId: lastMessage.userId,
                                    type: lastMessage.type,
                                    name: lastMessage.name,
                                    content: lastMessage.content,
                                    timestamp: lastMessage.timestamp,
                                });
                            }
                        } else {
                            // 如果聊天室在store不存在
                            // 新增聊天室
                            context.commit(mutationTypes.CHAT_ADD_ROOM, { 
                                room: transform.transformRoom(room),
                                members: room.Members ?
                                    room.Members.map(m => transform.transformRoomMember(m)) : undefined,
                                lastMessage: room.LastMessage ?
                                    transform.transformRoomMessage(room.LastMessage) : undefined,
                            });
                        }
                    }

                    // NOTICE: 移除聊天室先不做，會誤刪一些網頁自動產生的聊天室，例如:全站群聊
                    // 移除聊天室
                    // const removedRoomIds = []
                    // context.state.rooms.forEach((r) => {
                    //     if (!rooms.find((item) => item.RoomId === r.id)) {
                    //         removedRoomIds.push(r.id);
                    //     }
                    // })
                    // removedRoomIds.forEach((roomId) => {
                    //     context.commit(mutationTypes.CHAT_REMOVE_ROOM, {
                    //         roomId: roomId,
                    //     });
                    // })
                }
            } else {
                console.error(`chat syncWhenReconnected failed, result code ${code}`);
            }
        } catch (err) {
            console.error(err);
        }
    }

    async doCustomerServiceOnOpenWindow(context, roomId, isAddCustomerServiceWaiting) {
        let room = context.state.rooms.find((item) => {
            return item.id === roomId;
        });
        if (room.type === CONSTANT.roomType.CUSTOMER_SERVICE) {
            if (isAddCustomerServiceWaiting) {
                await this.addCustomerServiceWaitingOnOpenWindow(context);
            } else {
                this.addCustomerServiceQuestionList(context, roomId);
            }
        }
    }

    async addCustomerServiceWaitingOnOpenWindow(context) {
        await context.dispatch(actionTypes.CHAT_ADD_CUSTOMER_SERVICE_WAITING);
    }

    addCustomerServiceQuestionList(context, roomId) {
        context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
            roomId: roomId,
            type: CONSTANT.messageType.CUSTOMER_SERVICE_QUESTION_LIST,
            content: SETTING.messages.CUSTOMER_SERVICE_QUESTION_LIST(),
        });
    }

    addSiteGroupSystemMessage(context, roomId, siteGroupSystemMessage) {
        if (siteGroupSystemMessage) {
            context.commit(mutationTypes.CHAT_ADD_ROOM_MESSAGE, {
                roomId: roomId,
                type: CONSTANT.messageType.SITE_GROUP_SYSTEM_MESSAGE,
                content: siteGroupSystemMessage,
            });
        }
    }

    compressImage(file) {
        let isDone = false;
        let compressResult = undefined;

        if (file.size > 1024000) {
            new Compressor(file, {
                quality: 0.6,
                success: (result) => {
                    compressResult = result;
                    isDone = true;
                },
                error: (err) => {
                    console.log(err.message);
                    isDone = true;
                },
            });
        } else {
            compressResult = file;
            isDone = true;
        }

        return new Promise(function (resolve, reject) {
            (function waitForDone() {
                if (isDone) {
                    return resolve(compressResult);
                }
                setTimeout(waitForDone, 50);
            })();
        });
    }

    updateOnTalk(context, roomId, onTalkTime) {
        context.commit(mutationTypes.CHAT_UPDATE_ROOM_ON_TALK_STATE, {
            roomId: roomId,
            onTalkTime: onTalkTime
        });
    }

    afterOpenRoomWindow({context, newRoomId}) {

    }

    checkGroupRoomNameLength(name) {
        if (!name || name.length === 0) {
            return SETTING.messages.GROUP_ROOM_NAME_EMPTY();
        } else if (name.length > SETTING.GROUP_ROOM_NAME_MAX_SIZE) {
            return SETTING.messages.GROUP_ROOM_NAME_TOO_LONG();
        }
    }

    checkMemberInGroupRoom(context, sourceBuilder) {
        let builder = new GroupRoomMemberRequestBuilder(sourceBuilder);
        let existedLoginIds = [];
        builder.getRoomIds().forEach((roomId) => {
            let members = context.state.roomMemberContainers.find((item) => item.room.id === roomId).roomMembers;
            builder.getRoomMember(roomId).forEach((m) => {
                if (members.find((item) => item.userId === m.userId)) {
                    existedLoginIds.push(m.loginId);
                }
            });
        });

        if (existedLoginIds.length > 0) {
            return SETTING.messages.ADD_GROUP_ROOM_MEMBER_EXISTED(existedLoginIds.join());
        }
    }

    getDescendantMember(context, loginId) {
        let member;
        context.state.roomMemberContainers.some((item) => {
            if (item.room.type === CONSTANT.roomType.DESCENDANT
                && item.roomMembers) {
                member = item.roomMembers.find((item) => item.loginId.toUpperCase() === loginId.toUpperCase());
                if (member) {
                    return true;
                }
            }
        });
        return member;
    }

    getRoomMember(context, roomId, loginId) {
        let member;
        // NOTICE: 在一些情況下, 群組聊天室還未向資料庫拿成員資料, 但是僅需本人的資料時(例如:本人離開聊天室), 所以先判斷本人帳號並直接拿資料
        if (loginId.toUpperCase() === context.state.loginId.toUpperCase()) {
            return {
                userId: context.state.userId,
            };
        } else {
            context.state.roomMemberContainers.some((item) => {
                if (item.room.id === roomId && item.roomMembers) {
                    member = item.roomMembers.find((item) => item.loginId.toUpperCase() === loginId.toUpperCase());
                    if (member) {
                        return true;
                    }
                }
            });
            return member;
        }
    }

    async reEnterSiteGroupRoom(context) {
        // 檢查有無進入全站群組聊天室
        if (!context.state.siteGroupRoom
            || !context.state.siteGroupRoom.room) {
            return;
        }

        const siteGroupSessionToken = storage.session.get(storage.keys.CHAT_SITE_GROUP_SESSION_TOKEN);
        if (!siteGroupSessionToken) {
            return;
        }

        try {
            const result = await signalr.chatServer.reEnterSiteGroupRoom({ SessionToken: siteGroupSessionToken });
            const code = result.Code;
            switch (code) {
                case CONSTANT.code.SUCCESS:
                    break;
                default:
                    console.error(`[reEnterSiteGroupRoom] failed, result code ${code}`);
                    break;
            }
        } catch (err) {
            console.error(err);
        }
    }

    async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
